import styles from "./StaffReports.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";

import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import IconAndName from "../../components/IconAndName/IconAndName";
import { FaUserPlus } from "react-icons/fa";
import { LuClock3 } from "react-icons/lu";
import CopyRight from "../../components/CopyRight/CopyRight";

const data = [
  {
    _id: "1",
    staffName: "John Jacob",
    appStatus: "App Installed",
    lastInvited: "22/06/2025",
  },
  {
    _id: "2",
    staffName: "John Jacob",
    appStatus: "App Installed",
    lastInvited: "22/06/2025",
  },
  {
    _id: "3",
    staffName: "John Jacob",
    appStatus: "App Not Installed",
    lastInvited: null,
  },
  {
    _id: "4",
    staffName: "John Jacob",
    appStatus: "App Not Installed",
    lastInvited: null,
  },
];
  

function StaffReports() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleAddProgram = () => {
    dispatch(openModal("addProgram"));
  };
  const handleSendInvite = (item) => {
    // Later you can dispatch modal or API call here
    console.log("Send invite clicked for:", item.staffName);
  };

  const handleSendInviteModal = () => {
    dispatch(openModal("mailInviteStaffSend"));
  };

  const handleActionSelect = (option) => {
    if (option === "Edit email invite") {
      dispatch(openModal("mailInviteStaffEdit"));
    } else if (option === "Invitation log") {
      // Handle invitation log if needed
      console.log("Invitation log selected");
    }
  };
  

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        staffName: item.staffName,
        status: (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span>{item.appStatus}</span>
            {item.lastInvited && (
              <span style={{ fontSize: "12px", color: "gray" }}>
                Last Invited on {item.lastInvited}
              </span>
            )}
          </div>
        ),
        invite: (
          <span
            style={{ color: "var(--Primary_Color)", cursor: "pointer" }}
            onClick={() => handleSendInvite(item)}
          >
            Send
          </span>
        ),
      };
    });
  };
  

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Staff Name", accessor: "staffName" },
    { title: "Status", accessor: "status" },
    { title: "Invite", accessor: "invite" },
  ];
  

  const displayData = getColumnData(data);

  return (
    <div className={styles.copyright}>
      <div className={styles.programcontainer}>
        <div className={styles.container}>
          <div className={styles.cardsrow}>
            <div className={styles.resultandcount}>
              <ResultAndCount
                label="Staff With Installation"
                count={10}
                bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Staff Without Installation"
                count={2}
                bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
                textColor="Black_Color"
              />
            </div>
            <div className={styles.inviteButtonWrapper}>
              <IconAndName
                title="Send Email Invite"
                bgColor="Primary_Color"
                onClick={handleSendInviteModal}
              />
              <Action
                options={["Edit email invite", "Invitation log"]}
                onSelect={handleActionSelect}
              />
            </div>
          </div>

          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search by Staff Name"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>

              <div className={styles.dropdown}>
                <Dropdown
                  label="Installation Status"
                  options={["Room1", "Room2"]}
                />
                <Dropdown label="Staff Status" options={["Room1", "Room2"]} />
              </div>
            </div>

            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>

            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default StaffReports;
